import React from "react";
import { Link } from "react-router-dom";
import PersonIcon from "@material-ui/icons/Person";
import LocalHospitalIcon from "@material-ui/icons/LocalHospital";
import PeopleIcon from "@material-ui/icons/People";
import { LANDING_CONFIG } from "../../config/landingConfig";

const PortalCard = ({ portal, index }) => {
  const IconComponent = getIconComponent(portal.icon);
  const ButtonIconComponent = getIconComponent(portal.button.icon);
  
  return (
    <div 
      className="portal-card" 
      style={{ animationDelay: `${index * 0.2}s` }}
      role="article"
      aria-labelledby={`portal-title-${portal.id}`}
    >
      <div className={`portal-icon gradient-${getGradientNumber(portal.gradient)}`}>
        <IconComponent style={{ fontSize: '3rem', color: 'white' }} aria-hidden="true" />
      </div>
      <h3 id={`portal-title-${portal.id}`} className="portal-title">
        {portal.title}
      </h3>
      <p className="portal-description">
        {portal.description}
      </p>
      <ul className="portal-features" role="list">
        {portal.features.map((feature, featureIndex) => (
          <li key={featureIndex} className="portal-feature" role="listitem">
            <span aria-hidden="true">✓</span> {feature}
          </li>
        ))}
      </ul>
      <Link 
        to={portal.button.link}
        className="portal-button"
        aria-label={`${portal.button.text} for ${portal.title.toLowerCase()}`}
      >
        <ButtonIconComponent style={{ marginRight: '8px' }} aria-hidden="true" />
        {portal.button.text}
      </Link>
    </div>
  );
};

const getIconComponent = (iconName) => {
  const iconMap = {
    PersonIcon: PersonIcon,
    LocalHospitalIcon: LocalHospitalIcon,
    PeopleIcon: PeopleIcon,
  };
  return iconMap[iconName] || PersonIcon;
};

const getGradientNumber = (gradientName) => {
  const gradientMap = {
    primary: 1,
    secondary: 2,
    tertiary: 3,
    quaternary: 4,
  };
  return gradientMap[gradientName] || 1;
};

const PortalsSection = () => {
  const { portals } = LANDING_CONFIG;

  return (
    <section className="portals-section" aria-labelledby="portals-title">
      <h2 id="portals-title" className="section-title white">
        {portals.title}
      </h2>
      <div className="portals-grid" role="list">
        {portals.items.map((portal, index) => (
          <PortalCard 
            key={portal.id} 
            portal={portal} 
            index={index}
            role="listitem"
          />
        ))}
      </div>
    </section>
  );
};

export default PortalsSection;